var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('admin-box-item',{attrs:{"title":"복제","useTab":false}},[_c('div',[_vm._v("복제하시겠습니까?")]),_c('div',{staticClass:"btn-group-justify-end"},[_c('button',{staticClass:"button is-light",on:{"click":_vm.cancelModal}},[_vm._v("취소")]),_c('button',{staticClass:"button is-primary",on:{"click":_vm.confirmModal}},[_vm._v("확인")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }